export default {
  namespaced: true,
  alarm_rules: {
    title: "Rules",
    rule_id: "ID",
    description: "Description",
    name: "Name",
    user_id: "User",
    tenant_id: "Tenant",
  },
  match_rules: {
    name_label: "Enter identifier name",
    description_label: "Enter description",
    tenant_label: "Assign tenants to the rule",
    alarm_type_label: "Assign alarm type to the rule",

    general: "General rule data",
    providers: "Providers",
    camera: "Cameras",
    table: "Matching table",

    assign_camera: "Assign cameras",
    main_camera: "Select the cameras to assign",
    main_provider: "Select the providers to assign",
    assign_provider: "Assign providers",
    main_provider: "Select the provider to which you want to assign the matches",
    second_provider: "Select a provider to display its field catalog",
    missing_provider: "You must select a provider",
    min_match_rule: "You must add at least one match",
    new_match_rule: "Add new match",

    tenant: "Tenant",
    name: "Rule name",
    description: "Description",
    provider: "Provider",
    alarm_type: "Alarm type",

    field: "Field catalog",
    action: "Action",
    type: "Type",
    value: "Value"
  },
  match_rules_action: {
    contains: "Contains",
    equal_to: "Equal to",
    no_equal_to: "Not equal to",
    greater_than: "Greater than",
  },
  match_rules_card: {
    camera_applied: "Matches will apply only if the cameras are:",
    provider_applied: "Matches will apply only if the providers are:",
    match_rule_table: "The matching table only applies to the assigned providers, cameras, and tenants",

    apply_to: "Apply match:",
    on_param: "On parameter:",
    with_values: "With value: | With values:"
  }
};